import requests from 'api/index';

const prefixURL = '/mail';

export default {
  getPolicyInternalDomainList: () => requests.post(`${prefixURL}/rest/v1/policy/internal/domain/list`),
};
